import React from 'react';
import { choices } from './choices';
import GoogleAnalytics from "react-ga";
import TagManager from 'react-gtm-module';
import { PRESTAMO_URL, PERSONAL_URL, INCOME_URL, COBORROWER_URL, COLLATERAL_URL, SELECTOR_URL, SIMPLE_CHAT_URL, SHORT_URL, CAR_URL, PROPUESTA_URL, UW_CONTACT_URL, PREAPROBACION_URL, UW_DOCUMENTS_URL, GOOGLE_ANALYTICS_ID, FORCE_FB_TRACKING } from "./config";


var env_name = require('./env_data.json');
var env = require('./env.json')[env_name.ENV_NAME || 'local']; 

if (env_name.ENV_NAME == 'production' || FORCE_FB_TRACKING) {
    let FBPixelId = '655388214833626'
    if (location.pathname.split('/')[3] === 'hd') FBPixelId = '236646953831577'
    if (location.pathname.split('/')[3] === 'ce') FBPixelId = '2374133592810678'

    // <!-- Facebook Pixel Code -->
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', FBPixelId);
    fbq('track', 'PageView');
    // <!-- End Facebook Pixel Code -->
}

GoogleAnalytics.initialize(GOOGLE_ANALYTICS_ID);

TagManager.initialize({gtmId: 'GTM-NH8TQFZ'})

export function parseJSON(response) {
  return new Promise((resolve) => response.json()
    .then((json) => resolve({
      status: response.status,
      ok: response.ok,
      json,
    })));
}

export function debounce(fn, delay) {
  var timer = null;
  return function () {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

export function formatMoney(number) {
    return parseFloat(number).toLocaleString('es-AR');
}

export function goToNoti(evt, obj, noti){
    try{evt.preventDefault();}catch(e){}
    readNoti(evt, noti.uuid);
    obj.props.history.push(noti.link); //check for cases not to follow link
}

export function readNoti(evt, uuid){
    try{evt.preventDefault();}catch(e){}
    if (!uuid){
        return;
    }
    let link = '/notificaciones/' + uuid;
    fetch(link, {
        method: "DELETE",
        headers: {
            Accepts: "application/json"
        },
        credentials: 'include',
    });
}

export function loadNotifications(data, obj){
    let errorCount = 0;
    if (data == undefined || obj.notifications == undefined){
        return true;
    }
    try{obj.notifications.clear();}catch(e){}
    for (var i in data.notifications){
        let noti = data.notifications[i];
        errorCount += (noti.level == 'error' ? 1 : 0)
        obj.notifications[noti.level](
            noti.body,
            "",
            {
                handleOnClick: (evt) => goToNoti(evt, obj, noti),
                onCloseClick: (evt) => readNoti(evt, noti.uuid),
                closeButton: true,
                tapToDismiss: false,
                timeOut: (noti.level == 'error' ? 3600*2*1000:7000) //2 hs or 7 seconds
            }
        );
    }
    return (errorCount == 0);
}

export function validateNext(data, obj){
    return loadNotifications(data, obj);
}

export function FformatMoney(n){
    return formatMoney(Math.floor(n));
}

export function CformatMoney(n){
    return formatMoney(Math.ceil(n));
}

export const getFormURL = (apptype) => SIMPLE_CHAT_URL.replace(':apptype', apptype.toLowerCase());
export const getShortFormURL = (apptype) => SHORT_URL.replace(':apptype', apptype.toLowerCase());

export const getURL = (status, apptype, defaultRedirect = '/register') => {
    if (!status) return  '/'
    const statusDictionary = {
        1: PRESTAMO_URL,
        2: PERSONAL_URL,
        3: INCOME_URL,
        4: COBORROWER_URL,
        5: COLLATERAL_URL,
        9: SELECTOR_URL,
        10: SELECTOR_URL,
    }

    const step = statusDictionary[status]
    return step ? `/${apptype.toLowerCase()}/completa-tus-datos${step}` : defaultRedirect;
}




export function getPropertyTypes(apptype, destination) {
    return choices.apptype[apptype.toUpperCase()].find(choice => choice.value === destination).property_type.map(({ text, value }) => [text, value])
 }

 export const getUrlState = url => {
    let x = url.split('/').slice(-1)[0]
    if (!x) x = url.split('/').slice(-2)[0]
    return (x);
 };


 export const geType = (tipo) =>{
    let tipoText
    if(tipo === 'HD') return tipoText = 'Hipoteca Directa';
    if(tipo === 'SP') return tipoText = 'Saldo de Precio';
    if(tipo === 'CE') return tipoText = 'Car Equity';
}

export const change15for11 = (tel) => {
    if (tel.slice(0, 2) === '15') return `11${tel.slice(2)}`;
    return tel;
}

export const oppositeCurrency = currency => currency === 'ARS' ? 'USD' : 'ARS';

export const amountType = {
    HD: 'requested',
    SP: 'capital',
    CE: 'requested',
    hd: 'requested',
    sp: 'capital',
    ce: 'requested',
    CP: 'requested',
    cp: 'requested',
};

export const detectMobile = () => {
    if(window.innerWidth <= 800) {
        return true;
    } else {
        return false;
    }
}

export const getEmail = (mail) => {
    return mail.split('@')[0]
}

export const capitalize = (fullName) => {
    return fullName.toLowerCase().split(' ').map((name) => name.charAt(0).toUpperCase() + name.substring(1)).join(' ')
}

export const hoverUVA = <span> En el monto de la cuota ya están contemplados todos los gastos de otorgamiento y mantenimiento del crédito.</span>

export const hoverAM = <span> Cuota de interes solo. En el monto de la cuota ya están contemplados todos los gastos de otorgamiento y mantenimiento del crédito.</span>

export const hoverBL = <span> Este es el capital a cancelar al momento de vender la propiedad o al cumplirse el plazo del crédito, lo que ocurra primero.</span>

export const hoverAmCapital = <span> Este es el capital a cancelar simultáneamente al finalizar el plazo del crédito.</span>

export const getMobileTitle = (url, destination, abtestData) => {

    let abtestTitle = (abtestData ==  'wording-credito') ? 'Crédito' : 'Préstamo';

    const TITLES = {
        'mi-prestamo': 'Usá tu auto como Garantía',
        'personales': 'Datos personales',
        'ingresos': 'Tus ingresos',
        'cotitulares': 'Datos del co-titular',
        'propiedad': 'Datos de la propiedad',
        'propuesta': (destination == 'PY') ? '¡' + abtestTitle + ' pre-calificado!' : '¡' + abtestTitle + ' pre-aprobado!',
        'simulador':'Editá la propuesta',
        'automovil':'Datos del vehículo',
        'preaprobacion': (destination == 'PY') ? 'Tu oferta pre-calificada' : 'Tu oferta pre-aprobada',
        'contacto': 'Conocé a tu asesor',
        'documentacion': 'Subí tu documentación',
        'revision': 'Revisando tu documentación',
        'login': 'Ingresá a tu cuenta',
        'registrate': 'Creá tu cuenta',
        'recupera-contrasena': 'Recuperá tu contraseña',
        'cambia-contrasena': 'Cambiá tu contraseña'
    }

    return TITLES[url]
}

export const getMobileBackLink = (url, apptype='hd') => {

    const LINKS = {
        'personales': PRESTAMO_URL,
        'ingresos': PERSONAL_URL,
        'cotitulares': INCOME_URL,
        'propiedad': COBORROWER_URL,
        'propuesta':(apptype == 'ce') ? CAR_URL : COLLATERAL_URL ,
        'simulador':PROPUESTA_URL,
        'automovil':COBORROWER_URL,
        'preaprobacion':PROPUESTA_URL,
        'contacto': PREAPROBACION_URL,
        'documentacion': UW_CONTACT_URL,
        'revision': UW_DOCUMENTS_URL,
    }
    return LINKS[url]
}

export const stringFormat = function(format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
};

export const abtest = (abtestData, cad) => {
    const wording = {
        'wording-credito': 'crédito',
    }
    let out = 'préstamo';
    if(abtestData == 'wording-credito'){
        out = wording[abtestData];
    }
    return (cad ? stringFormat(cad, out) : out);
}

export const destinationFB = {
    CD: "cancelacion_deudas",
    RO: "refaccion",
    OT: "otro",
    RC: "reparar_vehiculo",
    TR: "viajar",
    CP: "cancelar_plan",
    BH: "compra_inmueble",
    IN: "capital_de_trabajo"
}

export const hasNumber = (address) => {
    return /\d/.test(address);
}

export const isValidCharacter = (name, value) => {
    let latin_neg = /[\d!@#$%^,.°&*()_~þÞ+=|?¿¡\/"{}\[\]\\]/;
    let latin_addr_neg = /[!@$%^*_~þÞ+=|?¿¡"{}\[\]\\]/;
    let latin_mail_neg = /[,°()~þÞ¿¡\/"\[\]\\]/;
    if(name == "first_name" && latin_neg.test(value)){
        return false;
    }
    if(name == "last_name" && latin_neg.test(value)){
        return false;
    }
    if(name == "address" && latin_addr_neg.test(value)){
        return false;
    }
    if(name == "email" && latin_mail_neg.test(value)){
        return false;
    }
    if(name == "phone" && /[^\d+]/.test(value)){
        return false;
    }
    if(name == "patent" && /[^\wñÑ\d]/.test(value)){
        return false;
    }
    return true;     
}

export const fbGaEvents = (is_staff, trackingEvent, app_type, sessionid, step, value=0, extraData={}) => {

    let searchCookie = document.cookie.split('; ').find(cookie => cookie.includes(step))
    let sendData;

    if (!searchCookie){
        document.cookie = `${step}=${step};`;

        if ((window.ENV == 'production' || FORCE_FB_TRACKING) && !is_staff) {
            
            if(value && value !== 0){
                sendData = { ... extraData, "content_category": app_type, "value": value, "currency": "ARS" }
                gtag('event', 'conversion', {
                    send_to: app_type === 'HD' ? 'AW-815890395/lHWCIfy0IwBENv_hYUD' : 'AW-815890395/7srmCIqx3owBENv_hYUD',
                    transaction_id: sessionid,
                    value: value,
                });
                GoogleAnalytics.event({
                    category: trackingEvent,
                    action: app_type,
                    value: value,
                });
            }else {
                sendData = { ... extraData, "content_category": app_type }
                gtag('event', 'conversion', {
                    send_to: app_type === 'HD' ? 'AW-815890395/lHWCIfy0IwBENv_hYUD' : 'AW-815890395/7srmCIqx3owBENv_hYUD',
                    transaction_id: sessionid,
                });
                GoogleAnalytics.event({
                    category: trackingEvent,
                    action: app_type,
                });
            }
            window.fbq('track', trackingEvent, sendData);
            ga('send', 'pageview', step);
        }
    }
}
